import * as React from 'react';
import useRestService from '../shared/rest-service';
import { AppContext, AppProviderDispatch } from '../shared/app-context';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSegmentDelete() {
  const appState = React.useContext<AppProviderDispatch>(AppContext);
  const { fetchWrapper } = useRestService();
  const queryClient = useQueryClient();

  return useMutation<{ message: string; success: boolean }, Error, { segmentId: number }>(
    (segemtDelete) => {
      const { segmentId } = segemtDelete;
      return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}`, {
        method: 'DELETE'
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['segments']);
        queryClient.invalidateQueries(['segment']);
        queryClient.invalidateQueries(['available-compositions']);
        queryClient.invalidateQueries(['dependencies']);
      }
    }
  );
}
